import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ee5efedc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "RenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "答题过程中，任务一和任务二同时出现，你需要同时注意视觉目标和声音目标，它们可能单独出现，也可能同时出现", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "在看到四个“*”组成的空心正方形，或听到音高相同的声音时，要在保证准确的情况下尽快点击「发现目标」", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当它们同时出现时，你也仅需要点击一下「发现目标」", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "每题时间仅2s,总答题时长5分钟，做好准备后请点击开始答题", -1));
const _hoisted_7 = {
  class: "colFlex"
};
const _hoisted_8 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  const _component_EarTraining808 = _resolveComponent("EarTraining808");
  const _component_el_col = _resolveComponent("el-col");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [_hoisted_3, _hoisted_4, _hoisted_5, _hoisted_6]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [$data.status === -1 && !$props.reviewMode ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      type: "primary",
      onClick: _cache[0] || (_cache[0] = $event => $data.status = 1)
    }, {
      default: _withCtx(() => [_createTextVNode("开始答题")]),
      _: 1
    })) : (_openBlock(), _createBlock(_component_EarTraining808, {
      key: 1,
      items: $props.data,
      reviewMode: $props.reviewMode,
      onAnswer: $options.onAnswer
    }, null, 8, ["items", "reviewMode", "onAnswer"]))]),
    _: 1
  }), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_col, {
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.data.rightAnswer === 'Y' ? '发现目标' : '未发现目标'), 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_createElementVNode("span", {
        style: _normalizeStyle($props.review && $props.review.result === true ? {
          'color': 'green'
        } : {
          'color': 'red'
        })
      }, [_createTextVNode("您的答案： "), $props.review ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($props.review.answer === 'Y' ? '发现目标' : '未发现目标'), 1)) : _createCommentVNode("", true)], 4)]),
      _: 1
    })])]),
    _: 1
  })) : _createCommentVNode("", true)]);
}